import {
  ARCHIVE_BATCH_CAP,
  type ArchiveBatchRequest,
  type ArchiveBatchResponse,
  type ArchiveBatchSummary,
} from '../types/list-archive.types';

const EMPTY_SUMMARY: ArchiveBatchSummary = {
  updated: 0,
  unchanged: 0,
  refused: 0,
  notFound: 0,
  errored: 0,
};

/**
 * Runs one bulk archive / unarchive over any number of ids by chunking at the
 * server's hard cap (100 per call, always synchronous — no 202 path) and
 * merging the per-chunk `summary` and `results`. Duplicate ids are collapsed
 * first, matching what the server does. An empty selection returns an empty
 * summary without a request (the server would 400 on `ids: []`).
 */
export async function runArchiveBatch(
  ids: readonly string[],
  archived: boolean,
  call: (request: ArchiveBatchRequest) => Promise<ArchiveBatchResponse>,
): Promise<ArchiveBatchResponse> {
  const unique = [...new Set(ids)];
  const summary: ArchiveBatchSummary = { ...EMPTY_SUMMARY };
  const results: ArchiveBatchResponse['results'] = [];
  for (let start = 0; start < unique.length; start += ARCHIVE_BATCH_CAP) {
    const chunk = await call({ ids: unique.slice(start, start + ARCHIVE_BATCH_CAP), archived });
    summary.updated += chunk.summary.updated;
    summary.unchanged += chunk.summary.unchanged;
    summary.refused += chunk.summary.refused;
    summary.notFound += chunk.summary.notFound;
    summary.errored += chunk.summary.errored;
    results.push(...chunk.results);
  }
  return { summary, results };
}
